<style lang="less" scoped>
@import '../../../style/common/variable';
.first {position: relative;display: flex;flex-direction: column;justify-content: center;align-items: center;margin: 0px auto;background: #fff;font-family: AlibabaPuHuiTi-Medium;margin-bottom: 40px;}
.chxxb {display: flex;flex-direction: column;
p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex;flex-direction: column;
i {width: 50px;height: 3px;display: inline-block;background: #3c77bb;margin: auto;}}}
.formBox{width: 1180px;margin-left: -10px;margin-top: 20px;}
table {border-collapse: collapse;width: 100%;}
tr,td {border: 1px solid #f5eeee;padding: 5px;border: 1px solid #e2e1e1;}
.f_red {color: red;margin-right: 5px;}
.f_hid {color: #ffffff;margin-right: 5px;}
.td_left {width: 200px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
.td_right {text-align: left;background-color: #fcfcfc;padding-left: 10px;}
.td_right span{font-size: 16px;}
.el-input {width: 400px;}
.el-select {width: 400px;}
.el-form-item {margin-bottom: 0;float: left;}
.el-button{margin-top: 20px;}
/deep/.el-form-item__error {font-size: 16px;height: 40px;line-height: 40px;float: right;margin-left: 10px;position:static;padding-top: 0;}
@media screen and (max-width: @max-screen) {
  .first {margin-bottom: 20px;}
  .chxxb {
    p {line-height: 1.5; font-size: 18px; letter-spacing: normal;
      i {width: 30px;}
    }
  }
  .formBox {width: 100%; padding: 0 10px;}
  table {display: block; overflow-x: auto;}
  td {padding: 8px 5px; min-width: 80px;}
  .td_left {width: 30%;text-indent: 5px;font-size: 14px;}
  .td_right {width: 70%;padding-left: 5px;
    span {
      font-size: 14px;
    }
  }
  .el-input, .el-select {width: 100% !important;}
  .el-form-item {width: 100%; margin-bottom: 15px !important;}
  .el-button {width: 100%;margin-top: 15px;padding: 12px 0;}
  /deep/.el-form-item__error {font-size: 12px;height: auto;line-height: 1.2;float: none;margin-left: 0;}
}
</style>

<template>
  <div class="first" :style="screenWidth < 912 ? {'width': allWidth + 'px'} : '1200px'">
    <div class="chxxb" id="hyrc">
      <p><span>参展报名表</span><i></i></p>
      <el-form ref="form" :model="form" :rules="rules" class="formBox">
        <table>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('type1')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>选择项(任选一项)
            </td>
            <td class="td_right">
              <el-form-item>
                <el-radio v-model="form.type1" label="个人"><span class="radio">个人</span></el-radio>
                <el-radio v-model="form.type1" label="企业"><span class="radio">企业</span></el-radio>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('type2')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>选择项(任选一项)
            </td>
            <td class="td_right">
              <el-form-item>
                <el-radio v-model="form.type2" label="作为代表参加会议"><span class="radio">作为代表参加会议</span></el-radio>
                <el-radio v-model="form.type2" label="作为演讲者参加会议"><span class="radio">作为演讲者参加会议</span></el-radio>
                <el-radio v-model="form.type2" label="在活动中赞助或 展示"><span class="radio">在活动中赞助或展示</span></el-radio>
                <el-radio v-model="form.type2" label="媒体合作"><span class="radio">媒体合作</span></el-radio>
                <el-radio v-model="form.type2" label="其它咨询"><span class="radio">其它咨询</span></el-radio>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('namec')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>姓名
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.name" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('tel')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>电话
            </td>
            <td class="td_right">
              <el-form-item prop="tel">
                <el-input v-model="form.tel" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('maill')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>邮箱
            </td>
            <td class="td_right">
              <el-form-item prop="email">
                <el-input v-model="form.email" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('gsname')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司名称
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.gsname" :disabled="bool" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('gsaad')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司地址
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.gsaad" :disabled="bool" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('gstype')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司性质
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.gstype" :disabled="bool" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('couture')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>所属国家
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.nation" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('city')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>所属城市
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.city" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">
              <span v-if="isMandatory('opacity')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>留言
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.text" class="input" style="width:960px;"></el-input>
              </el-form-item>
            </td>
          </tr>
        </table>
      </el-form>
    </div>
    <el-button type="primary" @click="submit">提交</el-button>
  </div>
</template>

<script>
/**
 * 何宽
 * 参展报名页
 */
export default {
  data()
  {
    //邮箱验证规则
    let InputEmail = (rule, value, callback) =>
    {
      let regtel = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!value)
        return callback(new Error('邮箱不能为空'))
      else
      {
        if (!regtel.test(value))
          callback(new Error('请输入正确的邮箱'))
        else
          callback()
      }
    }
    // 手机验证规则
    let InputTel = (rule, value, callback) =>
    {
      let regtel = /^1[3|4|5|7|8][0-9]{9}$/
      if (!value)
        return callback(new Error('电话不能为空'))
      else
      {
        if (!regtel.test(value))
          callback(new Error('请输入正确的联系电话'))
        else
          callback()
      }
    }
    return {
      form: {
        type1: '',
        type2: '',
        name: '',
        email: '',
        tel: '',
        gsname: '',
        gsaad: '',
        gstype: '',
        nation: '',
        city: '',
        text: ''
      },
      screenWidth: window.innerWidth,
      bool: false,
      GSXZ: [],
      //rules对象的属性名要与表单中prop绑定的名字一致
      rules: {
        email: [{ validator: InputEmail, trigger: 'blur' }],
        tel: [{ validator: InputTel, trigger: 'blur' }]
      },
      //表名
      tabname: 'dmcn_chxxb',
      //fld表数据
      fldData: []
    }
  },
  async created()
  {
    this.fldData = await window.public.validation(this.tabname)
  },
  updated()
  {
    if (this.form.type1 === '个人')
      this.bool = true
    else
      this.bool = false
  },
  methods: {
    // 报名
    submit()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 60,
        retAtt: 1,
        type1: this.form.type1,
        type2: this.form.type2,
        namec: this.form.name,
        maill: this.form.email,
        tel: this.form.tel,
        gsname: this.form.gsname,
        gsaad: this.form.gsaad,
        gstype: this.form.gstype || '3d',
        couture: this.form.nation,
        city: this.form.city,
        opacity: this.form.text
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '报名失败，请检查是否有未填写的内容或者填写不规范或者不符合填写规范', type: 'error', customClass: 'mzindex'})
        else
          this.$message({message: '报名成功', type: 'success', customClass: 'mzindex'})
      })
      for (let key in this.form)
        this.form[key] = null
    },
    // 返回
    backtrack()
    {
      this.$router.go(-1)
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    },
    //判断富文本内容是否必填
    isContentMandatory(colname)
    {
      return window.public.isMandatory(this.fldContentData, colname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/Chxxb.vue